import { render, staticRenderFns } from "./Rates.vue?vue&type=template&id=3ce90f9d&scoped=true"
import script from "./Rates.vue?vue&type=script&lang=js"
export * from "./Rates.vue?vue&type=script&lang=js"
import style0 from "./Rates.vue?vue&type=style&index=0&id=3ce90f9d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce90f9d",
  null
  
)

export default component.exports